export const ORDER_STATUS = {
  VOIDED: -1,
  FOR_INVOICE: 0,
  INVOICED: 1,
  INCOMPLETE_ITEMS: 2,
  COMPLETE_ITEMS: 3,
  LINKED_OUTPUT: 4
}